import {
  CropBox as ProtoCropBox,
  MedicalImageViewOptions,
} from '@/shared/api/protocol-ts/model/dto_common_image_view_options_pb';

import type { CropBox, PersistedPhotoTransform } from '../config';

export const mapTransformToViewOptions = (
  transform: PersistedPhotoTransform,
): Partial<MedicalImageViewOptions> => ({
  Rotation: transform.rotation,
  FlipHorizontal: transform.flipHorizontal,
  CropBox: transform.cropBox
    ? new ProtoCropBox({
        X: transform.cropBox.x,
        Y: transform.cropBox.y,
        Width: transform.cropBox.width,
        Height: transform.cropBox.height,
      })
    : new ProtoCropBox({ X: 0, Y: 0, Width: 0, Height: 0 }),
  Zoom: transform.zoom,
  PanX: transform.panX,
  PanY: transform.panY,
});

export const hasPhotoTransformFields = (
  viewOptions: MedicalImageViewOptions,
): boolean => {
  const hasRotation =
    viewOptions.Rotation !== undefined && viewOptions.Rotation !== 0;
  const hasFlip =
    viewOptions.FlipHorizontal !== undefined &&
    viewOptions.FlipHorizontal !== false;
  const hasCrop =
    viewOptions.CropBox !== undefined &&
    viewOptions.CropBox.Width > 0 &&
    viewOptions.CropBox.Height > 0;
  const hasZoom = viewOptions.Zoom !== undefined && viewOptions.Zoom !== 1;
  const hasPanX = viewOptions.PanX !== undefined && viewOptions.PanX !== 0;
  const hasPanY = viewOptions.PanY !== undefined && viewOptions.PanY !== 0;

  return hasRotation || hasFlip || hasCrop || hasZoom || hasPanX || hasPanY;
};

export const mapViewOptionsToTransform = (
  viewOptions: MedicalImageViewOptions,
  imageAspectRatio: number,
): PersistedPhotoTransform => {
  const protoCrop = viewOptions.CropBox;
  const cropBox: CropBox | null =
    protoCrop && protoCrop.Width > 0 && protoCrop.Height > 0
      ? {
          x: protoCrop.X,
          y: protoCrop.Y,
          width: protoCrop.Width,
          height: protoCrop.Height,
        }
      : null;

  return {
    rotation: viewOptions.Rotation ?? 0,
    flipHorizontal: viewOptions.FlipHorizontal ?? false,
    cropBox,
    imageAspectRatio,
    zoom: viewOptions.Zoom ?? 1,
    panX: viewOptions.PanX ?? 0,
    panY: viewOptions.PanY ?? 0,
  };
};
